"use client";

import type { HTMLAttributes, ReactNode, FC, Ref } from "react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { mergeClasses, rem } from "@huub-web/utils";
import { motion } from "motion/react";

import { placeholderStyle } from "./Placeholder.css";

export type PlaceholderProps = {
  className?: string;
  height?: string;
  width?: string;
  gridColumn?: string;
  gridRow?: string;
  children?: ReactNode;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
} & RecipeVariants<typeof placeholderStyle> &
  HTMLAttributes<HTMLDivElement>;

/**
 * A placeholder component that can be used to show loading states.
 */
export const Placeholder: FC<PlaceholderProps> = ({
  variant = "loading",
  height = rem(100),
  width,
  gridColumn,
  gridRow,
  alignSelf,
  size = "xs",
  style,
  className,
  children,
  ref,
}) => (
  <motion.div
    ref={ref}
    className={mergeClasses(
      placeholderStyle({ variant, alignSelf, size }),
      className,
    )}
    style={{ ...style, height, width, gridColumn, gridRow }}
  >
    {children}
  </motion.div>
);
